import { StepLayout } from './StepLayout';
import { useEffect } from 'react';
import ColorPalette from './ColorPalette';
import useChat from '../hooks/useChatSlice';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { useDispatch } from 'react-redux';
import { IframeUtils, UsageTrackerUtils } from 'feature-unboxing-common';
import { useTheme } from 'foundations-theming/utils';
import { NextButton } from './Wizard/NextButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const {
  TrackerActions
} = UsageTrackerUtils;
export default function ThirdStep({
  step,
  onNext
}) {
  const dispatch = useDispatch();
  const {
    chat,
    set
  } = useChat();
  const theme = useTheme();
  const lightTextColor = theme.color['fill-surface-default'];
  const darkTextColor = theme.color['text-core-default'];
  useEffect(() => {
    dispatch(TrackerActions.trackPageView({
      screen: 'third-step'
    }));
  }, [dispatch]);
  return /*#__PURE__*/_jsxs(StepLayout, {
    chatOnly: false,
    step: 3,
    i18nKey: "thirdStep",
    children: [/*#__PURE__*/_jsxs(FormLabel, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.thirdStep.colorPicker"
      }), /*#__PURE__*/_jsx(HelpIcon, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.thirdStep.colorPickerTooltip"
        }),
        marginInlineStart: "100"
      })]
    }), /*#__PURE__*/_jsx(ColorPalette, {
      color: chat.accentColor,
      onChange: color => set({
        accentColor: color,
        lightTextColor,
        darkTextColor
      })
    }), /*#__PURE__*/_jsx(NextButton, {
      step: step,
      onClick: onNext,
      isDone: true
    }), IframeUtils.isInIframe() && /*#__PURE__*/_jsx("div", {
      id: "signup-embedded"
    })]
  });
}